import {Prompt as ReactPrompt} from 'react-router-dom';
import {useBeforeUnload} from './useBeforeUnload';

export const Prompt = (props) => {
  useBeforeUnload(props);
  return <ReactPrompt {...props}/>;
};
